import { z } from 'zod';

export const AccountAccessFlowStatusSchema = z.enum([
  'WAITING_FOR_INPUT',
  'PROCESSING',
  'FINISHED',
  'ABORTED',
  'EXCEPTION',
]);

export const AccountAccessFlowProcessingReasonSchema = z.enum([
  'AWAITING_REDIRECT_URL',
  'AWAITING_USER_REDIRECT',
  'AWAITING_DECOUPLED_AUTHORISATION',
]);

export const AccountAccessFinalStatusSchema = z.enum([
  'AUTHORISATION_GRANTED',
  'AUTHORISATION_ABORTED',
  'AUTHORISATION_TERMINATED',
  'DATA_RETRIEVED',
  'FAILED',
]);

export const AccountAccessOngoingStatusSchema = z.enum([
  'NEW',
  'AWAITING_AUTHORISATION',
]);

export const AccountAccessStatusSchema = z.enum([
  ...AccountAccessFinalStatusSchema.options,
  ...AccountAccessOngoingStatusSchema.options,
]);

export const AccountAccessFlowProcessingWaitingForRedirectUrlSchema = z.object({
  status: z.literal(AccountAccessFlowStatusSchema.enum.PROCESSING),
  details: z.object({
    reason: z.enum([
      AccountAccessFlowProcessingReasonSchema.enum.AWAITING_REDIRECT_URL,
      AccountAccessFlowProcessingReasonSchema.enum
        .AWAITING_DECOUPLED_AUTHORISATION,
    ]),
  }),
});

export const AccountAccessFlowProcessingWaitingForUserRedirectSchema = z.object(
  {
    status: z.literal(AccountAccessFlowStatusSchema.enum.PROCESSING),
    details: z.object({
      reason: z.literal(
        AccountAccessFlowProcessingReasonSchema.enum.AWAITING_USER_REDIRECT
      ),
      redirect: z.object({
        url: z.string().url(),
        directUrl: z.string().url(),
      }),
    }),
  }
);
